import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 3V21H23V3H1ZM5 9H9.5V11H5V9ZM5 13H9.5V15H5V13ZM18 10C18 10.9537 17.466 11.7826 16.6807 12.2042C18.0328 12.6886 19 13.9813 19 15.5V16.5H12V15.5C12 13.9813 12.9672 12.6886 14.3193 12.2042C13.534 11.7826 13 10.9537 13 10C13 8.61929 14.1193 7.5 15.5 7.5C16.8807 7.5 18 8.61929 18 10Z"}}]};

const VerifyFilled = Vue.extend<IconProps>({
  name: 'VerifyFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'verify-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default VerifyFilled;
